import { useQuery } from '@apollo/client';
import { GET_RELATE_PRODUCT } from './product.gql';

export const useGetRelateProduct = ({ originalUrlKey }: { originalUrlKey: string }) => {
  const { data: relateProductData } = useQuery(GET_RELATE_PRODUCT, {
    fetchPolicy: 'cache-and-network',
    variables: {
      urlKey: originalUrlKey,
    },
  });
  const relatedProducts = (relateProductData?.products?.items?.[0]?.related_products || []).filter(Boolean).slice(0, 4);

  return {
    relatedProducts,
  };
};
